<template>
  <div class="solution-categroy">
    <div class="group" v-for="group in categroy.list" :key="group.id">
      <div class="group-title">
        <img class="icon" :src="getImageUrl(group.icon)" />
        <span class="name">{{ group.dictLabel }}</span>
      </div>
      <template v-if="group.children?.length">
        <div
          class="group-item"
          v-for="item in group.children"
          :key="item.id"
          @click="linkTo(item)"
        >
          <div class="imgs">
            <img class="icon" :src="item.icon" />
          </div>
          <div class="text">
            <div class="name">{{ item.productName }}</div>
            <div class="desc">{{ item.productAlias }}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <el-empty class="empty-box" />
      </template>
    </div>
    <div class="follow">
      <div>
        <img class="img" src="@/assets/images/code1.png" />
        <div class="txt">联系我们<br />了解更多</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup name="PageHeader">
import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getHeaderTop } from "@/api/home";
import { checkDevice, getImageUrl } from "@/utils/index";
import { getProPageApi } from "@/api/module/product";
import { getDictApi } from "@/api/module/common";
import { apiImgUrl } from "@/utils/index";
const router = useRouter();
const route = useRoute();
const emits = defineEmits(["update:show"]);
const props = withDefaults(
  defineProps<{
    show?: boolean;
  }>(),
  {
    show: false, // 菜单导航是否显示
  }
);
const categroy: any = reactive({
  list: [],
  /* list: [
    {
      id: 1,
      title: "数据产品",
      icon: "meun_icon_shuju.png",
      children: [
        {
          id: 2,
          title: "数据资产管理平台",
          icon: "meun_product_img1.png",
          desc: "全链路数据资产平台",
        },
        {
          id: 3,
          title: "智能数据分级分类",
          icon: "meun_product_img2.png",
          desc: "可信流通，协同治理",
        },
        {
          id: 4,
          title: "实时数据风控平台",
          icon: "meun_product_img3.png",
          desc: "可控可溯数据平台",
        },
        {
          id: 5,
          title: "数据资产价值评估",
          icon: "meun_product_img4.png",
          desc: "数据应用流通平台",
        },
        {
          id: 6,
          title: "I0C智能运营平台",
          icon: "meun_product_img5.png",
          desc: "数据应用流通平台",
        },
      ],
    },
    {
      id: 10,
      title: "人工智能",
      icon: "meun_icon_AIzhineng.png",
      children: [
        {
          id: 12,
          title: "数据资产管理平台",
          icon: "meun_product_img5.png",
          desc: "全链路数据资产平台",
        },
        {
          id: 13,
          title: "智能数据分级分类",
          icon: "meun_product_img4.png",
          desc: "可信流通，协同治理",
        },
        {
          id: 14,
          title: "实时数据风控平台",
          icon: "meun_product_img2.png",
          desc: "可控可溯数据平台",
        },
        {
          id: 15,
          title: "数据资产价值评估",
          icon: "meun_product_img1.png",
          desc: "数据应用流通平台",
        },
      ],
    },
  ], */
});
const linkTo = (item: any) => {
  router.push("/products?id=" + item.id);
  if (checkDevice()) {
    emits("update:show", false);
  }
};
 
const getPage = () => {
  getProPageApi().then((res: any) => {
    if (res && res.data) {
      res.data.forEach((item: any) => {
        item.icon = apiImgUrl(item.icon);
      });
      if (categroy.list.length) {
        categroy.list = categroy.list.map((group: any) => {
          const matchingItems = res.data.filter(
            (item: any) => item.productType == group.dictValue
          );
          return {
            ...group,
            children: matchingItems,
          };
        });
      }
    }
  });
};
//获取分类
const getCategroy = async () => {
  await getDictApi("product_type").then((res: any) => {
    if (res && res.data.length) {
      categroy.list = res.data.map((item: any) => {
        item.icon = "meun_icon_shuju.png";
        return item;
      });
    }
  });
};
onMounted(async () => {
  await getCategroy();
  await getPage();
});
</script>

<style scoped lang="scss">
.solution-categroy {
  display: flex;
  padding: 30px 100px;
  height: 100%;
  overflow-y: auto;
  .group {
    flex: 1;
    border-right: 1px solid #eee;
    margin-right: 50px;
    padding-right: 50px;
    .group-title {
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        img {
          display: block;
          max-width: 100%;
        }
      }
      .name {
        margin-left: 10px;
        line-height: 1;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .group-item {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #eee;
      .imgs {
        width: 60px;
        height: 60px;
        background-color: #ecf4ff;
        margin-right: 20px;
        img {
          display: block;
          // max-width: 100%;
          width: 100%;
        }
      }
      .text {
        .name {
          font-size: 17px;
          font-weight: 500;
          color: #000;
        }
        .desc {
          margin-top: 5px;
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
  .follow {
    padding: 100px 100px;
    width: 180px;
    .img {
      display: block;
      height: auto;
			width: 100%;
      margin: auto;
    }
    .txt {
      margin-top: 10px;
      text-align: center;
      font-size: 18px;
      line-height: 1.8;
      font-weight: 600;
    }
  }
}
@media screen and (max-width: 1024px) {
  .solution-categroy {
    display: block;
    padding: 30px;
    border: 0;
    margin: 0;
    .group {
      margin: 0 0 40px 0;
      padding: 0 0 20px 0;
      border-right: 0;
      border-bottom: 1px solid #eee;
      .group-title {
        margin-bottom: 20px;
        .icon {
          width: 32px;
        }
        .name {
          font-size: 32px;
        }
      }
      .group-item {
        .imgs {
          width: 88px;
          height: 88px;
          margin-right: 30px;
          img {
            width: 100%;
          }
        }
        .text {
          .name {
            font-size: 30px;
          }
          .desc {
            font-size: 28px;
          }
        }
      }
    }
    .follow {
      padding: 40px 0;
      width: 100%;
      img {
        max-width: 50%;
      }
    }
  }
} 
</style>
